(function (global) {
  'use strict';
  if (!global.JeremiasDwColorEngine) return;
  const api = global.JeremiasDwColorEngine.createSystemAdapter({
    systemKey: 'DW-BLACK',
    systemLabel: 'Jeremias DW-BLACK',
    skuPrefix: '16-'
  });
  global.JeremiasDwBlackRules = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
